import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledTabWrapper = styled(Flexbox)`
    ${({theme}) => css`
        border: 1px solid ${theme.palette.neutral['300']};
        width: min-content;
        border-radius: 8px;
    `}
`

export const StyledTabItem = styled.div<{$isActive?: boolean}>`
    ${({$isActive, theme}) => css`
        padding: ${theme.spacing * 2.5}px ${theme.spacing * 4}px;
        cursor: pointer;
        border-right: 1px solid ${theme.palette.neutral['300']};
        transition: background 0.3s;
        &:first-child {
            border-radius: 8px 0 0 8px;
        }
        &:last-child {
            border-right: none;
            border-radius: 0 8px 8px 0;
        }
        color: ${theme.palette.neutral['700']};
        font-weight: 500;
        ${theme.typography.textSm};

        ${$isActive &&
        css`
            background: ${theme.palette.secondary['400']};
            color: ${theme.palette.secondary['100']};
        `}
    `}
`
